import styles from "./TradingSignals.module.scss";
import { FC, useEffect, useState } from "react";
import StarsBar from "@/components/stars-bar/StarsBar";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import dayjs from "dayjs";
import { useAtomValue } from "jotai";
import { greyState } from "@/lib/store";
import { classNames, formatDate } from "@/lib/utils";
import { Chip, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";

interface PropsTypes {
    date: number;
    significance: number;
    direction: string;
    absMeanPriceChange: number | string;
    triggerType: string;
    overviewPage?: boolean;
    mobile?: boolean;
}

const TradingSignals: FC<PropsTypes> = ({ date, significance, direction, absMeanPriceChange, triggerType, overviewPage, mobile }) => {
    const grey = useAtomValue(greyState);
    const isLargeScreen = useMediaQuery("(min-width: 2560px)");
    const [fontSize, setFontSize] = useState("10px");

    const CHIP_STYLES = {
        width: "fit-content",
        fontWeight: "600",
        borderWidth: "2px",
        "@media screen and (min-width: 1280px)": {
            fontSize: "8px",
            "& .MuiChip-label": {
                padding: "2px 6px",
            },
        },
        "@media screen and (min-width: 1920px)": {
            fontSize: "10px",
            "& .MuiChip-label": {
                padding: "6px",
            },
        },
    };

    useEffect(() => {
        if (isLargeScreen) {
            setFontSize("18px");
        } else {
            setFontSize("10px");
        }
    }, [isLargeScreen]);

    return (
        <div className={classNames(styles.TradingSignals, styles[overviewPage && "overview-page"])}>
            <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={classNames(styles["signal-date"], "positive")} sx={{ textTransform: "none" }}>
                {formatDate(dayjs.utc(date))}
            </Typography>
            <Typography variant="body2" className={styles["trigger-type"]} style={{ color: grey, textTransform: "initial", lineHeight: 1, fontSize: overviewPage && fontSize }}>
                {triggerType?.replace(direction, "")}
            </Typography>
            <Box>
                <StarsBar percentage={significance} bigFont={overviewPage} />
            </Box>

            <Box>
                <Chip className={styles.chip} variant="outlined" color={direction?.toUpperCase() === "BUY" ? "success" : "error"} sx={{ ...CHIP_STYLES }} size="small" label={direction?.toUpperCase()} />
            </Box>
            <Box className={styles.return}>
                <Typography variant="body1" style={{ fontWeight: "700", fontSize: overviewPage && fontSize }}>
                    {Number(absMeanPriceChange).toFixed(2)}%
                </Typography>
                <Typography variant="body2" style={{ color: grey, textTransform: "initial", fontSize: overviewPage && fontSize }}>
                    return
                </Typography>
            </Box>
        </div>
    );
};

export default withStockStamp(TradingSignals, "significance", { title: "Last Signal", align: "center" }, "Trading Signals");
